<template>
  <div class="machine-view-tabs btn-group" role="group">
    <router-link tag="button" to="/machines/" class="btn btn-outline-light ">
      <small><font-awesome-icon icon="list" /></small> Списком
    </router-link>
    <router-link tag="button" to="/map/" class="btn btn-outline-light ">
      <small><font-awesome-icon icon="map-marker-alt" /></small> На карте
    </router-link>
  </div>
</template>

<script>
  export default {
    name: 'MachineListMapTabs',
  }
</script>

<style lang="scss">
  @import "boot";
  .machine-view-tabs {

  }
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/machine-list-map-tabs.vue